import React from 'react';
import { ModalNoticeUI } from '@cube3/ui/src/Modal/ModalNoticeUI';
import { useModalActions } from '../../Modals/modalActions';

import { ResourceIdentifier } from '@cube3/common/model/resource-types';
import { ModalReceiverProps } from '../../Modals/ModalManager';
import MenuButton from '@cube3/ui/src/Buttons/MenuButton';
import { Divider } from '@cube3/cubicle/src/core/atoms/Divider/Divider';
import { iconAdd, iconClipShare } from '@cube3/ui/src/icons/GeneralSVG';
import Button from '@cube3/cubicle/src/core/atoms/Button/Button';
import { VBox } from '@cube3/cubicle/src/core/templates/layout/Flex';
import { isMobile } from 'react-device-detect';
import { MobileSubmenuSlider } from '@cube3/cubicle/src/components/Surface/MobileSubmenuSlider';
import { SizeVariants } from '@cube3/cubicle/src/theme/themes';

interface Props extends ModalReceiverProps {
  modalContext: { parentResource: ResourceIdentifier };
}

export const AttachContractPrompt: React.FunctionComponent<Props> = (props) => {
  const { modalContext } = props;
  const { parentResource } = modalContext;
  const modalActions = useModalActions();

  return (
    <>
      {isMobile ? (
        <MobileSubmenuSlider onClose={() => modalActions.previousModal()}>
          <div
            style={{
              display: 'flex',
              flexDirection: 'column',
              alignItems: 'flex-start',
              gap: 12,
              margin: '20px 0px'
            }}
          >
            <Button
              label="Create new contract"
              iconLeft="add"
              size={SizeVariants.lg}
              onClick={() =>
                modalActions.openModal('create_contract', {
                  parentResource
                })
              }
            />
            <Divider color="line3" length={'100%'} />
            <Button
              label="Attach existing contract"
              iconLeft="link"
              size={SizeVariants.lg}
              onClick={() =>
                modalActions.openModal(
                  'attach_existing_contract',
                  {
                    parentResource
                  },
                  false
                )
              }
            />
          </div>
        </MobileSubmenuSlider>
      ) : (
        <ModalNoticeUI
          title={`Attach contract to ${parentResource.type}`}
          onCloseEvent={() => modalActions.previousModal()}
          component="form"
          footerRightComponent={
            <Button
              buttonStyle="ghost"
              label="Cancel"
              onClick={() => modalActions.previousModal()}
            />
          }
        >
          <VBox gap={8}>
            <MenuButton
              text="Create new contract"
              path={iconAdd}
              variant={'withIcon'}
              colorVariant="ghost3"
              size="big"
              onClick={() =>
                modalActions.openModal('create_contract', {
                  parentResource
                })
              }
            />
            <Divider color="line3" />
            <MenuButton
              text="Attach existing contract"
              path={iconClipShare}
              variant={'withIcon'}
              colorVariant="ghost2"
              size="big"
              onClick={() =>
                modalActions.openModal(
                  'attach_existing_contract',
                  {
                    parentResource
                  },
                  false
                )
              }
            />
          </VBox>
        </ModalNoticeUI>
      )}
    </>
  );
};
